/* @flow weak */

'use strict';

const React = require('react');

const Blank = React.createClass({

  render() {
    return (
      <div></div>
    );
  }
});

module.exports = Blank;


// WEBPACK FOOTER //
// ./src/base/scripts/components/controls/Blank.jsx